var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.items,"hide-default-footer":"","disable-pagination":"","disable-sort":""}})}
var staticRenderFns = []

export { render, staticRenderFns }